module.exports = __webpack_public_path__ + "img/horizontal_4_2_5012.7ebe65d6.png";